<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,4C14.72,4,14.47,4.11,14.29,4.29C14.29,4.29,12,6.59,12,6.59C12,6.59,12,4,12,4C12,3.45,11.55,3,11,3C11,3,1,3,1,3C0.45,3,0,3.45,0,4C0,4,0,12,0,12C0,12.55,0.45,13,1,13C1,13,11,13,11,13C11.55,13,12,12.55,12,12C12,12,12,9.41,12,9.41C12,9.41,14.29,11.7,14.29,11.7C14.47,11.89,14.72,12,15,12C15.55,12,16,11.55,16,11C16,11,16,5,16,5C16,4.45,15.55,4,15,4C15,4,15,4,15,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'MobileVideo',
} as DefineComponent
</script>
